import React from 'react'
import PropTypes from 'prop-types'
import { useTheme } from 'styled-components'
import Instance from 'highcharts'
import HighCharts from 'highcharts-react-official'
import { GlobalStyle, Root } from './ColumnsChart.styles'

/**
 * The ColumnsChart's component.
 */
const ColumnsChart = props => {
  const { categories, data, dataLabelFormatter, id, labelFormatter, tooltipFormatter } = props
  const theme = useTheme()
  const options = {
    accessibility: { enabled: false },
    chart: {
      height: 400,
      type: 'column'
    },
    plotOptions: {
      series: {
        borderWidth: 0,
        dataLabels: {
          enabled: true,
          formatter: dataLabelFormatter,
          style: {
            color: theme.palette.brand.black1,
            fontSize: '8px',
            textOutline: 'none'
          }
        }
      }
    },
    series: data,
    title: { text: '' },
    tooltip: { formatter: tooltipFormatter },
    yAxis: {
      title: { text: '' }
    },
    xAxis: {
      categories,
      endOnTick: true,
      labels: { formatter: labelFormatter },
      min: 0,
      startOnTick: false
    }
  }

  return (
    <>
      <GlobalStyle />
      <Root id={id}>
        <HighCharts highcharts={Instance} options={options} />
      </Root>
    </>
  )
}

ColumnsChart.defaultProps = {
  dataLabelFormatter: function () {
    return this.y
  }
}

ColumnsChart.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.string),
  data: PropTypes.any,
  dataLabelFormatter: PropTypes.func,
  id: PropTypes.string.isRequired,
  labelFormatter: PropTypes.func,
  tooltipFormatter: PropTypes.func
}

export default ColumnsChart
